export const WRAPPER_GAP = 24;
export const WRAPPER_PADDING = 20;
